module.exports = __webpack_public_path__ + "img/logo-p2-cargo.ebfed2a1.webp";